import React, { useState } from 'react';
import { Box, Paper, Typography, useTheme } from '@mui/material';
import { useContext } from 'react';
import { UiContext } from 'shared/lib/contexts/uiContext';
import { useGeneralAdaptive } from 'shared/hooks/useGeneralAdaptive';
import IconLogo from 'shared/icons/logo';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { makeTransition } from 'shared/lib/utils/utils';
import IconFooterLogo from 'shared/icons/iconFooterLogo';
import { useBooleanScreens } from 'shared/hooks/useBooleanScreens';

export const FAVORITES_ANCHOR = '#favorites';

export default function Footer() {
  const { t } = useTranslation();
  const theme = useTheme();
  const {
    getFontSize,
    spacings: { sp },
  } = useContext(UiContext);
  const navigate = useNavigate();

  const { generalPaddingX } = useGeneralAdaptive();
  const { isLessTablet, cb } = useBooleanScreens();

  const [isHover, setIsHover] = useState(false);

  return (
    <Paper
      elevation={4}
      square
      sx={{
        'display': 'flex',
        'flexDirection': 'column',
        'alignItems': 'center',
        'justifyContent': 'center',
        'py': sp.s70,
        '& a': {
          'transition': makeTransition(['color'], { duration: '125ms' }),

          '&:hover': {
            color: 'primary.dark',
          },
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: 1,
          gap: sp.s50,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            px: generalPaddingX,
            width: 1,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              [theme.breakpoints.down('tablet')]: {
                flexDirection: 'column',
                gap: 5,
                alignItems: 'start',
              },
              justifyContent: 'space-between',
              alignItems: 'center',
              width: 1,
              maxWidth: 1440,
            }}
          >
            <IconLogo
              onClick={() => {
                navigate('/', { replace: false });
              }}
            ></IconLogo>

            <Box
              sx={{
                display: 'flex',
                gap: sp.s120,
                [theme.breakpoints.down('tablet')]: {
                  width: 1,
                  justifyContent: 'space-between',
                },
              }}
            >
              <Link to="/" reloadDocument={true}>
                <Typography
                  sx={{
                    fontSize: `${
                      isLessTablet ? '14px' : getFontSize('f18')
                    } !important`,
                    fontWeight: 'bold',
                  }}
                >
                  {t('breadcrumbs.main')}
                </Typography>
              </Link>
              <Link to="/profile" reloadDocument={true}>
                <Typography
                  sx={{
                    fontSize: `${
                      isLessTablet ? '14px' : getFontSize('f18')
                    } !important`,
                    fontWeight: 'bold',
                  }}
                >
                  {t('common.profile')}
                </Typography>
              </Link>
              <Link to={`/profile${FAVORITES_ANCHOR}`} reloadDocument={true}>
                <Typography
                  sx={{
                    fontSize: `${
                      isLessTablet ? '14px' : getFontSize('f18')
                    } !important`,
                    fontWeight: 'bold',
                  }}
                >
                  {t('common.favorite')}
                </Typography>
              </Link>
            </Box>

            {!(isLessTablet || cb === 'tablet') && (
              <Link to="mailto:penskoita@transport.mos.ru">
                <Typography
                  sx={{
                    fontSize: `${
                      isLessTablet ? '14px' : getFontSize('f18')
                    } !important`,
                    fontWeight: 'bold',
                  }}
                >
                  penskoita@transport.mos.ru
                </Typography>
              </Link>
            )}
          </Box>
        </Box>

        <Box
          sx={{ height: '1px', width: 1, bgcolor: 'custom.lightGrey' }}
        ></Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: sp.s15,
            px: generalPaddingX,
          }}
          component="a"
          href="https://ictransport.ru/?utm_source=knowledge_base"
          target="_blank"
          onMouseEnter={() => setIsHover(true)}
          onMouseLeave={() => setIsHover(false)}
        >
          <IconFooterLogo
            extColor={
              isHover ? theme.palette.primary.dark : theme.palette.text.primary
            }
            isAutoscallable={false}
          ></IconFooterLogo>
          {isLessTablet ? (
            <Typography
              sx={{
                fontSize: `${
                  isLessTablet ? '12px' : getFontSize('f16')
                } !important`,
                fontWeight: 'bold',
              }}
            >
              Сайт разработан ИЦ &laquo;Безопасный транспорт&raquo;
            </Typography>
          ) : (
            <Typography
              sx={{
                fontSize: `${
                  isLessTablet ? '12px' : getFontSize('f16')
                } !important`,
                fontWeight: 'bold',
              }}
            >
              Сайт разработан Инновационным центром &laquo;Безопасный
              транспорт&raquo;
            </Typography>
          )}
        </Box>
      </Box>
    </Paper>
  );
}
